var logger = {
  DEBUG: 'debug',
  INFO: 'info',
  WARN: 'warn',
  ERROR: 'error',
  log: function log(level, message) {
    var _console;

    /* eslint-disable no-console */
    var method = console[level] ? level : 'log';

    for (var _len = arguments.length, params = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
      params[_key - 2] = arguments[_key];
    }

    (_console = console)[method].apply(_console, ['[griffith] ' + message].concat(params));
    /* eslint-enable no-console */

  },
  debug: function debug() {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    this.log.apply(this, [this.DEBUG].concat(args));
  },
  info: function info() {
    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    this.log.apply(this, [this.INFO].concat(args));
  },
  warn: function warn() {
    for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }

    this.log.apply(this, [this.WARN].concat(args));
  },
  error: function error() {
    for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
      args[_key5] = arguments[_key5];
    }

    this.log.apply(this, [this.ERROR].concat(args));
  }
};
var isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
var isAndroid = /(android)/i.test(navigator.userAgent);
var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
var ua = {
  isMobile: isMobile,
  isAndroid: isAndroid,
  isSafari: isSafari
};
/**
 * Copied from https://github.com/video-dev/hls.js/blob/master/src/is-supported.js
 */

function getMediaSource() {
  if (typeof window !== 'undefined') {
    return window.MediaSource || window.WebKitMediaSource;
  }
}

function isMSESupported() {
  var mediaSource = getMediaSource();
  var sourceBuffer = window.SourceBuffer || window.WebKitSourceBuffer;
  var isTypeSupported = mediaSource && typeof mediaSource.isTypeSupported === 'function' && mediaSource.isTypeSupported('video/mp4; codecs="avc1.42E01E,mp4a.40.2"');
  var sourceBufferValidAPI = !sourceBuffer || sourceBuffer.prototype && typeof sourceBuffer.prototype.appendBuffer === 'function' && typeof sourceBuffer.prototype.remove === 'function';
  return !!isTypeSupported && !!sourceBufferValidAPI;
}

function isHlsNativeSupported() {
  var video = document.createElement('video');
  return Boolean(video.canPlayType('application/vnd.apple.mpegURL'));
}
/**
 * 获得最大公约数
 * @param {number} a
 * @param {number} b
 */


function getGCD(a, b) {
  if (!Number.isInteger(a) || !Number.isInteger(b)) {
    throw new Error('params must be interger number');
  }

  if (a === 0) {
    return Math.abs(b);
  }

  if (b === 0) {
    return Math.abs(a);
  }

  return getGCD(b, a % b);
}
/**
 * 约分
 * @param {number} a
 * @param {number} b
 */


function reduce(a, b) {
  if (a === 0 || b === 0) {
    throw new Error('params must not be zero');
  }

  var gcd = getGCD(a, b);
  return [a / gcd, b / gcd];
}

function sequence() {
  for (var _len6 = arguments.length, fns = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
    fns[_key6] = arguments[_key6];
  }

  return function () {
    for (var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
      args[_key7] = arguments[_key7];
    }

    return fns.reduce(function (_, fn) {
      return fn.apply(void 0, args);
    }, null);
  };
}

export { getGCD, isHlsNativeSupported, isMSESupported, logger, reduce, sequence, ua };